// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c3ffadb2","62":"2029b0dd","253":"153ea48c","272":"7280ab0d","650":"4a1d8c42","672":"f664792f","953":"09573bc3","991":"843cf1df"}[chunkId] + ".chunk.js";
};